import { useTranslation } from 'react-i18next';

import { AlertDialog, Button } from '~/components';

type Props = {
  loading?: boolean;
  onConfirm: () => void;
};

export const JobPostCancelledConfirmDialog = ({ loading, onConfirm }: Props) => {
  const { t } = useTranslation(['jobPosts']);

  return (
    <AlertDialog.Body status="warning">
      <AlertDialog.Title>{t('jobPosts:contextMenu.dialogs.cancelled.title')}</AlertDialog.Title>

      <AlertDialog.Description>{t('jobPosts:contextMenu.dialogs.cancelled.description')}</AlertDialog.Description>

      <AlertDialog.Actions>
        <Button loading={loading} onClick={onConfirm}>
          {t('jobPosts:contextMenu.dialogs.cancelled.actions.confirm')}
        </Button>
      </AlertDialog.Actions>
    </AlertDialog.Body>
  );
};
